"use strict";
import { el, round, esc, srTable } from "../util";
export function renderBars(host, data) {
  host.innerHTML = "";
  host.classList.add("bc-wrap");
  const total = data.survey_total || data.groups.reduce((s, g) => s + (g.survey_count || 0), 0);
  const rows = data.groups.map((g) => {
    const sp = g.survey_pct != null ? g.survey_pct : total ? 100 * (g.survey_count || 0) / total : 0;
    return { label: g.label, survey: sp, baseline: g.baseline_pct || 0 };
  });
  const max = data.axis_max || Math.ceil(Math.max.apply(null, rows.map((r) => Math.max(r.survey, r.baseline))) / 10) * 10;
  const title = data.bars_title || data.title;
  const subtitle = data.bars_subtitle || data.subtitle;
  const description = data.bars_description || data.description;
  if (title) host.insertAdjacentHTML("beforeend", `<h2 class="bc-head">${esc(title)}</h2>`);
  if (subtitle) host.insertAdjacentHTML("beforeend", `<p class="bc-sub">${esc(subtitle)}</p>`);
  if (description) host.insertAdjacentHTML("beforeend", `<p class="bc-desc">${esc(description)}</p>`);
  const W = 720;
  const LAB = 210;
  const GUT = 46;
  const R = 50;
  const BAR = 15;
  const BGAP = 5;
  const TOP = 14;
  const x0 = LAB;
  const xr = W - GUT;
  const pw = xr - x0;
  const H = TOP + rows.length * R + 44;
  const X = (v) => x0 + v / max * pw;
  const svg = el("svg", { viewBox: `0 0 ${W} ${H}`, class: "bc-svg", role: "img" });
  svg.setAttribute(
    "aria-label",
    `${title}. ` + rows.map((r) => `${r.label}: MSEG respondents ${round(r.survey)}%, OUSD students ${round(r.baseline)}%`).join("; ")
  );
  const step = max > 40 ? 10 : max > 20 ? 5 : 2;
  for (let v = 0; v <= max + 1e-3; v += step) {
    const gx = round(X(v), 1);
    svg.appendChild(el("line", { x1: gx, y1: TOP - 2, x2: gx, y2: TOP + rows.length * R - 6, class: "bc-grid" }));
    const t = el("text", { x: gx, y: TOP + rows.length * R + 10, class: "bc-tick", "text-anchor": "middle" });
    t.textContent = `${v}%`;
    svg.appendChild(t);
  }
  rows.forEach((r, i) => {
    const bandTop = TOP + i * R;
    const cy = bandTop + R / 2;
    const barsTop = bandTop + (R - (2 * BAR + BGAP)) / 2;
    const g = el("g", {
      class: "bc-row",
      "aria-label": `${r.label}, MSEG respondents ${round(r.survey)} percent, OUSD students ${round(r.baseline)} percent`
    });
    g.style.setProperty("--d", `${i * 70}ms`);
    const lab = el("text", { x: 4, y: cy, class: "bc-lab", "dominant-baseline": "middle" });
    lab.textContent = r.label;
    g.appendChild(lab);
    [
      ["bc-bar-survey", r.survey, barsTop],
      ["bc-bar-base", r.baseline, barsTop + BAR + BGAP]
    ].forEach(([cls, val, by]) => {
      const w = Math.max(round(X(val) - x0, 1), 0);
      g.appendChild(el("rect", { x: x0, y: by, width: w, height: BAR, rx: 3, class: `bc-bar ${cls}` }));
      const vt = el("text", { x: round(X(val), 1) + 5, y: by + BAR / 2, class: "bc-val", "dominant-baseline": "middle" });
      vt.textContent = `${round(val)}%`;
      g.appendChild(vt);
    });
    svg.appendChild(g);
  });
  host.appendChild(svg);
  host.insertAdjacentHTML(
    "beforeend",
    `<div class="bc-legend"><span class="k"><span class="sw bc-bar-survey"></span>MSEG Respondents (n=${total})</span><span class="k"><span class="sw bc-bar-base"></span>OUSD students</span></div>`
  );
  if (data.source) {
    host.insertAdjacentHTML(
      "beforeend",
      `<p class="bc-src">${esc(data.source)}${data.updated ? ` \xB7 updated ${esc(data.updated)}` : ""}</p>`
    );
  }
  host.insertAdjacentHTML(
    "beforeend",
    srTable(
      title || "Representation by group",
      ["Group", "MSEG Respondents %", "OUSD students %"],
      rows.map((r) => [r.label, round(r.survey, 1), round(r.baseline, 1)])
    )
  );
  requestAnimationFrame(() => svg.classList.add("bc-anim"));
}
